<template>

  <div class="wrapper">
    <div class="sidebar" data-color="blue" data-image="../assets/img/sidebar-5.jpg">
      <!--
          Tip 1: You can change the color of the sidebar using: data-color="purple | blue | green | orange | red"

          Tip 2: you can also add an image using data-image tag
      -->
      <div class="sidebar-wrapper">
        <div class="logo">
          <a href="#" class="simple-text logo-mini">R</a>
          <a href="#" class="simple-text logo-normal">RAEFTON</a>
        </div>

        <ul class="nav">
          <li class="nav-item active">
            <a class="nav-link" href="#/raw_templates/t_dashboard">
              <i class="nc-icon nc-delivery-fast"></i>
              <p>RFQs</p>
            </a>
          </li>
          <li class="nav-item ">
            <a class="nav-link" href="#/raw_templates/t_createrfq">
              <i class="nc-icon nc-paper-2"></i>
              <p>CREATE RFQ</p>
            </a>
          </li>
          <li class="nav-item ">
            <a class="nav-link" href="#/raw_templates/t_contacts">
              <i class="nc-icon nc-circle-09"></i>
              <p>CONTACTS</p>
            </a>
          </li>

        </ul>
      </div>
      <div class="sidebar-background" style="background-image: url(/static/img/sidebar-5.jpg) "></div>
    </div>
    <div class="main-panel">
      <!-- Navbar -->
      <nav class="navbar navbar-expand-lg ">
        <div class="container-fluid">
          <div class="navbar-wrapper">
            <div class="navbar-minimize">
              <button id="minimizeSidebar" class="btn btn-primary btn-fill btn-round btn-icon d-none d-lg-block">
                <i class="fa fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i class="fa fa-navicon visible-on-sidebar-mini"></i>
              </button>
            </div>
            <a class="navbar-brand" href="#pablo" id="test"> Contacts</a>
          </div>
          <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
            <span class="navbar-toggler-bar burger-lines"></span>
          </button>

        </div>
      </nav>
      <!-- End Navbar -->
      <div class="content">
          <div class="container-fluid">
              <div class="row">
                  <div class="col-md-12">
                      <div class="card data-tables">
                          <div class="card-body table-striped table-no-bordered table-hover dataTable dtr-inline table-full-width">
                              <div class="toolbar">
                                  <!-- Here you can write extra buttons/actions for the toolbar -->
                              </div>
                              <div class="fresh-datatables">
                                  <table id="datatables_contacts" class="table table-striped table-no-bordered table-hover" cellspacing="0" width="100%" style="width:100%">
                                    <thead>
                                      <tr>
                                        <th>Email</th>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th>Website</th>
                                        <th>Phone Number</th>
                                        <th>Address</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td class="align-top">name@domain.com</td>
                                        <td class="align-top">John Smith</td>
                                        <td class="align-top">Person</td>
                                        <td class="align-top"><a href="www.google.com" target="_blank">google.com</a></td>
                                        <td class="align-top">519-555-1234</td>
                                        <td class="align-top">123 Main St.<br>Kitchener, ON<br>N2G 1G1<br>Canada</td>
                                      </tr>
                                    </tbody>
                                  </table>

                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button class="btn btn-primary btn-wd"><i class="fa fa-user"></i> Add Contact</button>
                </div>
              </div>
          </div>

      </div>
      <footer class="footer">
        <div class="container">
          <nav>
            <p class="copyright text-center">
              &copy; 2018 Raefton
            </p>
          </nav>
        </div>
      </footer>
    </div>
  </div>





</template>

<script>
  import router from '../../router'
  import apiService from '../../services/api.service'
  import config from '../../config'

  import "../../../static/js/jquery.dataTables.min.js"


  export default {
    name: 'Demo',
    data: function() {
      return {
        user: '',
        password: '',
        myname: 'Timmyy',
      }
    },
    mounted: function() {
      console.log("mounted------");
      initTables();
    },

    methods: {


    }
  }

  function initTables() {

    var vm = this;
    console.log( "test: " + $("#test").html() );


    var testdata = {
      "data": [
        {
          "customer": "John James",
          "shipper": "Pat Crossman",
          "consignee": "Jimmy C. Gerry",
          "created_date": "Mon Dec 18, 2017",
          "due_date": "Mon Dec 28, 2017",
          "status": '<strong>Assigned <i class="fa fa-square rfq_received"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
        {
          "customer": "John James II",
          "shipper": "Pat Crossman II",
          "consignee": "Jimmy C. Gerry II",
          "created_date": "Mon Dec 18, 2018",
          "due_date": "Mon Dec 28, 2018",
          "status": '<strong>Assigned <i class="fa fa-square rfq_declined"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
        {
          "customer": "Brian G. Baldree",
          "shipper": "Pat Crossman II",
          "consignee": "Jimmy C. Gerry II",
          "created_date": "Mon Dec 18, 2018",
          "due_date": "Mon Dec 28, 2018",
          "status": '<strong>Assigned <i class="fa fa-square rfq_viewed"></i></strong>',
          "actions": '<a href="#" class="btn btn-link btn-info"><i class="fa fa-fw fa-eye"></i></a><a href="#" class="btn btn-link btn-success"><i class="fa fa-fw fa-edit"></i></a><a href="#" class="btn btn-link btn-danger"><i class="fa fa-fw fa-trash"></i></a>'
        },
      ]};



    var mytable = $('#datatables').DataTable({
         "data": testdata.data,
         "columns": [
             {
                 "className": 'details-control',
                 "orderable": false,
                 "defaultContent": '',
                 "render": function () {
                     return '<i class="fa fa-plus-square" aria-hidden="true"></i>';
                 },
             },
             { "data": "customer" },
             { "data": "shipper" },
             { "data": "consignee" },
             { "data": "created_date" },
             { "data": "due_date" },
             { "data": "status" },
             { "data": "actions", "className": 'text-right' },
         ],

        "pagingType": "full_numbers",
        "lengthMenu": [
            [10, 25, 50, -1],
            [10, 25, 50, "All"]
        ],
        retrieve: true,
        responsive: true,
        language: {
            search: "_INPUT_",
            searchPlaceholder: "Search records",
        }

    });


    // Add event listener for opening and closing details
    $('#datatables tbody').on('click', 'td.details-control', function () {
        var tr = $(this).closest('tr');
        var row = mytable.row(tr);
        var tdi = tr.find("i.fa");

        if ( row.child.isShown() ) {
            // This row is already open - close it
            row.child.hide();
            tr.removeClass('shown');
            tdi.first().removeClass('fa-minus-square');
            tdi.first().addClass('fa-plus-square');

        }
        else {
            // Open this row
            row.child( formatDetailRow(row.data()) ).show();
            tr.addClass('shown');
            tdi.first().removeClass('fa-plus-square');
            tdi.first().addClass('fa-minus-square');
            // setTimeout( function() { tr.next().find("td").attr("colspan", "15").attr("width", "100%") }, 1000);
        }
    } );

    console.log("datatables init done!");
  }

  // https://datatables.net/examples/api/row_details.html
  function formatDetailRow ( d ) {

    // d is the original data object for the row
    // console.log( JSON.stringify(d) );

    return '<table class="table">'+
      '<thead>'+
          '<tr>'+
            '<th>Assignee</th>'+
            '<th>Assign Data</th>'+
            '<th>Due Date</th>'+
            '<th>Status</th>'+
            '<th>Total Quote</th>'+
            '<th class="text-right">Actions</th>'+
          '</tr>'+
      '</thead>'+
      '<tbody>'+
        '<tr>'+
          '<td>Eva Solomon</td>'+
          '<td>Mon Dec 18, 2017</td>'+
          '<td>Tue Dec 19, 2017</td>'+
          '<td>Open</td>'+
          '<td>$500.00</td>'+
          '<td class="text-right"><a href="#" class="btn btn-link btn-primary"><i class="fa fa-fw fa-plus"></i></a></td>'+
        '</tr>'+
      '</tbody>'+
    '</table>';

    /*
    return "colspan all of this now";


    return [
        'First child row',
        'Second child row',
        'Third child row'
    ];*/

  }


  // https://vuejsdevelopers.com/2017/04/22/vue-js-libraries-plugins/
  // https://laracasts.com/discuss/channels/vue/using-datatables-with-vue


</script>



// WEBPACK FOOTER //
// t_contacts.vue?b4da60ee